var cell_default = {
  "cell": "R-rOc",
  "header": "Yy-23",
  "selected": "ow85e",
  "editing": "TtvFE",
  "singleSelection": "FJ6Fk",
  "hideLastBlock": "Hbctr",
  "editorWrapper": "K2fb0",
  "viewerWrapper": "_2zZ-H",
  "hideFirstBlock": "B7-jL",
  "editor": "Uxx7w",
  "edit": "noffR",
  "view": "d4qgi",
  "editingToolbarWrapper": "Q9sO-",
  "selectAll": "_9A-xg",
  "disableSelection": "_5OANV"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
